module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-02.jpg"
    }
  })])]), _c('p', {
    staticClass: "noindenta"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "file_007"
    }
  }, [_c('em', [_vm._v("Needle felting is my passion and through this book I will share it with you. Most likely, you’ve dabbled in knitting, sewing, quilting, or even clay or woodworking. The bottom line is you probably like to work with your hands. When I’m doing a public demonstration, I often hear “I don’t need another complicated hobby or craft.” But needle felting is different! All you need to get started is some wool, a barbed needle, and a foam pad. You will be amazed at what you can create.")])])]), _c('a', {
    attrs: {
      "id": "file_007"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39fc46d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_007.vue
// module id = 72
// module chunks = 0